

export const frontMatter = {};
export const contentTitle = 'project32 (Shader Module)';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-core-project-32-md-8c1.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "GLSL Functions",
  "id": "glsl-functions",
  "level": 2
}, {
  "value": "project_position_to_clipspace",
  "id": "project_position_to_clipspace",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "project32-shader-module",
        children: "project32 (Shader Module)"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "project32"
      }), " shader module is an extension of the ", _jsx(_components.a, {
        href: "/docs/api-reference/core/project",
        children: "project"
      }), " shader module that adds some projection utilities."]
    }), "\n", _jsx(_components.h2, {
      id: "glsl-functions",
      children: "GLSL Functions"
    }), "\n", _jsx(_components.h3, {
      id: "project_position_to_clipspace",
      children: "project_position_to_clipspace"
    }), "\n", _jsxs(_components.p, {
      children: ["32 bit implementation of the ", _jsx(_components.code, {
        children: "project_position_to_clipspace"
      }), " interface."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-glsl",
        children: "vec4 project_position_to_clipspace(vec3 position, vec3 position64Low, vec3 offset)\nvec4 project_position_to_clipspace(vec3 position, vec3 position64Low, vec3 offset, out vec4 commonPosition)\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "Parameters:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "position"
        }), " - vertex position in the layer's coordinate system."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "position64Low"
        }), " - lower part of the vertex position, calculated as ", _jsx(_components.code, {
          children: "aLow = a - Math.fround(a)"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "offset"
        }), " - offset from the coordinate, in common space"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "commonPosition"
        }), " - projected position in the common space"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Returns:\nProjected position in the clipspace."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

